import React from "react";
import { Text as TextProps } from "../../interfaces/common";

export interface Props extends TextProps {
  children: any;
  id?: string;
}

const Text = ({ children, id }: Props) => {
  if (!children) return null;

  if (!Array.isArray(children)) {
    return null;
  }

  return (
    <>
      {children?.map((element: any) => {
        if (!element?.type) return <></>;
        switch (element?.type) {
          case "headingOne":
            return (
              <h1 id={`${id}H1`}>
                <Leaf id={`${id}H1`}>{element.children}</Leaf>
              </h1>
            );
          case "headingTwo":
            return (
              <h2 id={`${id}H2`}>
                <Leaf id={`${id}H2`}>{element.children}</Leaf>
              </h2>
            );
          case "headingThree":
            return (
              <h3 id={`${id}H3`}>
                <Leaf id={`${id}H3`}>{element.children}</Leaf>
              </h3>
            );
          case "blockquote":
            return (
              <blockquote id={`${id}BlockQuote`}>
                <Leaf id={`${id}BlockQuote`}>{element.children}</Leaf>
              </blockquote>
            );
          case "alignLeft":
            return (
              <div
                id={`${id}alignLeft`}
                style={{ textAlign: "left", listStylePosition: "inside" }}
              >
                <Text id={`${id}alignLeft`}>{element?.children}</Text>
              </div>
            );
          case "alignCenter":
            return (
              <div
                id={`${id}alignCenter`}
                style={{ textAlign: "center", listStylePosition: "inside" }}
              >
                <Text id={`${id}alignCenter`}>{element?.children}</Text>
              </div>
            );
          case "alignRight":
            return (
              <div
                id={`${id}alignRight`}
                style={{ textAlign: "right", listStylePosition: "inside" }}
              >
                <Text id={`${id}alignRigth`}>{element?.children}</Text>
              </div>
            );
          case "list-item":
            return (
              <li id={`${id}ListItem`}>
                <Leaf id={`${id}ListItem`}>{element.children}</Leaf>
              </li>
            );
          case "orderedList":
            return (
              <ol type="1" id={`${id}OrderedList`}>
                <Text id={`${id}OrderedList`}>{element?.children}</Text>
              </ol>
            );
          case "unorderedList":
            return (
              <ul id={`${id}UnorderedList`}>
                <Text id={`${id}UnorderedList`}>{element?.children}</Text>
              </ul>
            );
          case "link":
            return (
              <a href={element?.href} id={`${id}A`}>
                <Leaf id={`${id}A`}>{element.children}</Leaf>
              </a>
            );
          default:
            return (
              <p id={`${id}P`}>
                <Leaf id={`${id}P`}>{element.children}</Leaf>
              </p>
            );
        }
      })}
    </>
  );
};

const Leaf = ({ children, id }: any) => (
  <>
    {children?.map((item: any, idx: number) => {
      if (item.type) {
        return (
          <Text id={id} key={idx}>
            {[item]}
          </Text>
        );
      }
      return (
        <span key={idx} id={`${id}Span`} style={generateAttributes(item)}>
          {item.text || "\uFEFF"}
        </span>
      );
    })}
  </>
);

const generateAttributes = (props: any) => {
  const css: React.CSSProperties = {};

  if (props.lineHeight) {
    css.lineHeight = props.lineHeight;
  }
  if (props?.bold) {
    css.fontWeight = "bolder";
  }
  if (props.weight) {
    css.fontWeight = props.weight;
  }
  if (props?.italic) {
    css.fontStyle = "italic";
  }
  if (props?.fontFamily) {
    css.fontFamily = props.fontFamily;
  }
  if (props?.fontSize) {
    css.fontSize = props.fontSize;
  }
  if (props?.color) {
    css.color = props.color;
  }
  if (props?.bgColor) {
    css.background = props.bgColor;
  }
  if (props?.underline) {
    css.textDecoration = "underline";
  }
  if (props?.strikethrough) {
    css.textDecoration = "line-through";
  }

  return css;
};

export default Text;
